import { createGlobalStyle } from 'styled-components';

//* GLOBAL STYLES

export const GlobalStyle = createGlobalStyle`
  .extole-overlay-cta-wrapper .extole-overlay-cta-content .extole-minimized-section {
    background: #D2E0EA !important;
    color: ${({ theme }) => theme.colors.charcoal} !important;
  }

  .rc-pagination-item-active {
    background-color: ${({ theme }) => theme.colors.french} !important;
    border-color: ${({ theme }) => theme.colors.french} !important;
    color: white;
  }

  html {
    box-sizing: border-box;

    body {
      font-family: ${({ theme }) => theme.fonts.primary};
    }

    h1 {
        font-family: ${({ theme }) => theme.fonts.secondary.family};
        letter-spacing: ${({ theme }) => theme.fonts.secondary.letterSpacing};
        font-weight: ${({ theme }) => theme.old ? 'normal' : '300'};
        font-size: 95px;
        /* LEADING */
        line-height: normal;
    }
    h2 {
        font-family: ${({ theme }) => theme.fonts.secondary.family};
        letter-spacing: ${({ theme }) => theme.fonts.secondary.letterSpacing};
        font-weight: ${({ theme }) => theme.old ? 'normal' : '300'};
        font-size: 75px;
        line-height: normal;
    }
    h3 {
        font-family: ${({ theme }) => theme.fonts.secondary.family};
        letter-spacing: ${({ theme }) => theme.fonts.secondary.letterSpacing};
        font-weight: ${({ theme }) => theme.old ? 'normal' : '300'};
        font-size: 45px;
        line-height: normal;
    }
  }
  *, *:before, *:after {
    box-sizing: inherit;
  }
`;
